// extracted by mini-css-extract-plugin
export default {"contents":"sF-z","sectionHeading":"tF-z"};